
const digest = '334f4e8ed3a8e0458528ef2a52fd570fbd9b65d920753d29aa7bab0a4cb53d11';
const classes = {"wrapper":"_wrapper_jha4t_1"};
const css = `._wrapper_jha4t_1 {
  margin: -34px -24px;
  padding: 34px 24px;
  background-color: rgb(225, 236, 252);
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  